"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _DropdownButton = _interopRequireDefault(require("@react/react-spectrum/DropdownButton"));

var _CommentMenuItem = _interopRequireDefault(require("./CommentMenuItem"));

var _useCommentsDropdown2 = _interopRequireDefault(require("./useCommentsDropdown"));

var _svgs = require("../../../lib/svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/*
 * OverlayTrigger likes to return focus to the last focused item after the menu closes.
 * We do not want this to happen so passing an empty object, essentially no-ops this.
 */
var lastFocusNOOP = {
  focus: function focus() {}
};

var CommentDropdownMenu = /*#__PURE__*/_react.default.memo(function (_ref) {
  var assetData = _ref.assetData,
      compactLayout = _ref.compactLayout,
      creator = _ref.creator,
      handleDeleteBtnClick = _ref.handleDeleteBtnClick,
      handleEditBtnClick = _ref.handleEditBtnClick,
      handleOpenBtnClick = _ref.handleOpenBtnClick,
      handleResolveBtnClick = _ref.handleResolveBtnClick,
      imsData = _ref.imsData,
      isEditing = _ref.isEditing,
      isOffline = _ref.isOffline,
      isReply = _ref.isReply,
      isResolved = _ref.isResolved,
      showActive = _ref.showActive,
      userRole = _ref.userRole;

  var _useCommentsDropdown = (0, _useCommentsDropdown2.default)(assetData, compactLayout, creator, imsData, isEditing, isReply, isResolved, showActive, userRole),
      isVisible = _useCommentsDropdown.isVisible,
      items = _useCommentsDropdown.items;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "comment-item-dropdown-wrapper"
  }, isVisible ? /*#__PURE__*/_react.default.createElement(_DropdownButton.default, {
    alignRight: true,
    "aria-label": formatMessage({
      id: 'comments.arialabel.button.dropdownMenu'
    }),
    className: "comment-item-dropdown-button",
    lastFocus: lastFocusNOOP,
    menuClassName: "comment-item-dropdown-menu",
    onMouseDown: function onMouseDown(evt) {
      return evt.preventDefault();
    }
  }, /*#__PURE__*/_react.default.createElement(_CommentMenuItem.default, {
    "data-testid": "resolve",
    icon: _svgs.Resolve,
    isDisabled: isOffline,
    onMenuItemSelect: handleResolveBtnClick,
    value: formatMessage({
      id: 'comments.item.resolve'
    }),
    visible: items.resolve
  }), /*#__PURE__*/_react.default.createElement(_CommentMenuItem.default, {
    "data-testid": "unresolve",
    icon: _svgs.Unresolve,
    isDisabled: isOffline,
    onMenuItemSelect: handleOpenBtnClick,
    value: formatMessage({
      id: 'comments.item.open'
    }),
    visible: items.unresolve
  }), /*#__PURE__*/_react.default.createElement(_CommentMenuItem.default, {
    "data-testid": "edit",
    icon: _svgs.Edit,
    isDisabled: isOffline,
    onMenuItemSelect: handleEditBtnClick,
    value: formatMessage({
      id: 'comments.item.edit'
    }),
    visible: items.edit
  }), /*#__PURE__*/_react.default.createElement(_CommentMenuItem.default, {
    "data-testid": "delete",
    icon: _svgs.Delete,
    isDisabled: isOffline,
    onMenuItemSelect: handleDeleteBtnClick,
    value: formatMessage({
      id: 'comments.item.delete'
    }),
    visible: items.delete
  })) : null);
});

CommentDropdownMenu.displayName = 'CommentDropdownMenu';
CommentDropdownMenu.defaultProps = {
  compactLayout: false,
  imsData: {},
  isEditing: false,
  isOffline: false,
  isReply: false,
  isResolved: false,
  showActive: false,
  userRole: ''
};
CommentDropdownMenu.propTypes = {
  assetData: _propTypes.default.shape({
    ownerId: _propTypes.default.string
  }).isRequired,
  compactLayout: _propTypes.default.bool,
  creator: _propTypes.default.shape({
    id: _propTypes.default.string
  }).isRequired,
  handleDeleteBtnClick: _propTypes.default.func.isRequired,
  handleEditBtnClick: _propTypes.default.func.isRequired,
  handleOpenBtnClick: _propTypes.default.func.isRequired,
  handleResolveBtnClick: _propTypes.default.func.isRequired,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  isEditing: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  isReply: _propTypes.default.bool,
  isResolved: _propTypes.default.bool,
  showActive: _propTypes.default.bool,
  userRole: _propTypes.default.string
};
var _default = CommentDropdownMenu;
exports.default = _default;